const FEATURES = [
  {
    icon: "ri-fire-line",
    title: "海量影视资源",
    desc: "覆盖电影、电视剧、综艺三大品类，持续更新热门与高分作品。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维筛选检索",
    desc: "按题材、地区、年份与热度自由筛选，快速找到想看的内容。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "本地收藏追剧",
    desc: "一键收藏感兴趣的作品，收藏状态保存在本地，随时回来继续浏览。",
  },
  {
    icon: "ri-newspaper-line",
    title: "及时行业资讯",
    desc: "汇聚行业新闻、片场花絮与深度评论，第一时间了解影视动态。",
  },
];

export default function SiteIntroBand() {
  return (
    <section className="rounded-lg bg-primary-950 px-6 py-10 md:px-10 md:py-12">
      <div className="mb-8 max-w-2xl">
        <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
          关于 WWW.17C
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-background-300">
          WWW.17C 致力于打造一个纯粹的影视内容浏览与发现平台。我们希望用清晰的信息结构与舒适的阅读体验，
          让每一位影视爱好者都能快速找到心仪的作品，轻松掌握行业最新动态。
        </p>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f) => (
          <div key={f.title} className="rounded-lg bg-primary-900/60 p-5">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className={`${f.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-semibold text-background-50">{f.title}</h3>
            <p className="mt-2 text-xs leading-relaxed text-background-400">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}